<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <ContentSelect
      :cardContent="dataContent"
      :funcUpdateProgress="updateProgress"
    />
  </div>
</template>

<script>
import ContentSelect from "../../components/template/Chinese1/ContentSelect";
import { mapGetters } from "vuex";

import "../../assets/scss/_chineseStyle.scss";
export default {
  components: { ContentSelect },
  name: "HP03",
  data() {
    return {
      dataContent: {},
      CheckWidth: window.innerWidth.toString(),
      startTime: "",
    };
  },

  computed: {
    ...mapGetters({
      getdataContent: "template/getTemplateContent",
      getUserTemplate: "template/getUserTemplate",
    }),
  },

  watch: {
    getdataContent: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.dataContent = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },

    getUserTemplate: function(val) {
      this.userTemplateData = val;
      this.condition = [
        {
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        },
      ];
    },
  },
  mounted() {},
  created() {
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `HP03-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    updateProgress() {
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.dataContent._id,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
    },
  },
};
</script>

<style>
.displayNone {
  display: None;
}
.displayBlock {
  display: block;
}
</style>
